import { ref } from 'vue';
import SocioAPI from 'dashboard/api/fandata/socio';

// Estado compartilhado da consulta de sócio.
//
// Existe porque dois lugares mostram a mesma informação: o selo curto embaixo do nome do
// contato e a ficha completa no Painel do Torcedor. Sem compartilhar, cada um faria a própria
// requisição da MESMA conversa, e a tela pediria duas vezes o que precisa uma.
//
// Guarda só a conversa ATUAL, e não um histórico por conversa: os dois componentes olham sempre
// a mesma, e cache que cresce durante um turno inteiro de atendimento é vazamento disfarçado.
const atual = ref({ chave: null, dados: null });
let emVoo = null;

const chaveDe = (conversationId, cpf) => `${conversationId || ''}|${cpf || ''}`;

export function useFichaSocio() {
  // Devolve a promessa em voo quando já existe: se o selo e a ficha montarem no mesmo tick,
  // as duas chamadas viram uma.
  const garantir = (conversationId, cpf) => {
    if (!conversationId) return Promise.resolve(null);

    const chave = chaveDe(conversationId, cpf);
    if (atual.value.chave === chave) return Promise.resolve(atual.value.dados);
    if (emVoo && emVoo.chave === chave) return emVoo.promessa;

    const promessa = SocioAPI.get(conversationId)
      .then(({ data }) => data)
      // A base fora do ar não pode quebrar o painel: some a informação, o atendimento segue.
      .catch(() => ({ disponivel: false, motivo: 'indisponivel' }))
      .then(dados => {
        atual.value = { chave, dados };
        return dados;
      })
      .finally(() => {
        emVoo = null;
      });

    emVoo = { chave, promessa };
    return promessa;
  };

  const dadosDe = (conversationId, cpf) =>
    atual.value.chave === chaveDe(conversationId, cpf) ? atual.value.dados : null;

  return { garantir, dadosDe };
}
